export const MAIN_DEAL_SLUG = 'CAD'
export const TO_CURRENCY_SLUG = 'NGN'
export const TOAST_TIMEOUT = 10000
export const TOAST_ERROR_TIMEOUT = 15000
